/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChatChannel } from './ChatChannel';
import {
    ChatChannelFromJSON,
    ChatChannelFromJSONTyped,
    ChatChannelToJSON,
    ChatChannelToJSONTyped,
} from './ChatChannel';
import type { ChatMessage } from './ChatMessage';
import {
    ChatMessageFromJSON,
    ChatMessageFromJSONTyped,
    ChatMessageToJSON,
    ChatMessageToJSONTyped,
} from './ChatMessage';
import type { PrivateNote } from './PrivateNote';
import {
    PrivateNoteFromJSON,
    PrivateNoteFromJSONTyped,
    PrivateNoteToJSON,
    PrivateNoteToJSONTyped,
} from './PrivateNote';
import type { ChatChannelEvent } from './ChatChannelEvent';
import {
    ChatChannelEventFromJSON,
    ChatChannelEventFromJSONTyped,
    ChatChannelEventToJSON,
    ChatChannelEventToJSONTyped,
} from './ChatChannelEvent';

/**
 * A ChatChannel with all associated events and messages.
 * @export
 * @interface ChatChannelFull
 */
export interface ChatChannelFull {
    /**
     * The chat channel details
     * @type {ChatChannel}
     * @memberof ChatChannelFull
     */
    chatChannel: ChatChannel;
    /**
     * All events that occurred in this channel
     * @type {Array<ChatChannelEvent>}
     * @memberof ChatChannelFull
     */
    events: Array<ChatChannelEvent>;
    /**
     * All messages in this channel
     * @type {Array<ChatMessage>}
     * @memberof ChatChannelFull
     */
    messages: Array<ChatMessage>;
    /**
     * All private notes associated with this channel
     * @type {Array<PrivateNote>}
     * @memberof ChatChannelFull
     */
    notes: Array<PrivateNote>;
}

/**
 * Check if a given object implements the ChatChannelFull interface.
 */
export function instanceOfChatChannelFull(value: object): value is ChatChannelFull {
    if (!('chatChannel' in value) || value['chatChannel'] === undefined) return false;
    if (!('events' in value) || value['events'] === undefined) return false;
    if (!('messages' in value) || value['messages'] === undefined) return false;
    if (!('notes' in value) || value['notes'] === undefined) return false;
    return true;
}

export function ChatChannelFullFromJSON(json: any): ChatChannelFull {
    return ChatChannelFullFromJSONTyped(json, false);
}

export function ChatChannelFullFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatChannelFull {
    if (json == null) {
        return json;
    }
    return {
        
        'chatChannel': ChatChannelFromJSON(json['chatChannel']),
        'events': ((json['events'] as Array<any>).map(ChatChannelEventFromJSON)),
        'messages': ((json['messages'] as Array<any>).map(ChatMessageFromJSON)),
        'notes': ((json['notes'] as Array<any>).map(PrivateNoteFromJSON)),
    };
}

export function ChatChannelFullToJSON(json: any): ChatChannelFull {
    return ChatChannelFullToJSONTyped(json, false);
}

export function ChatChannelFullToJSONTyped(value?: ChatChannelFull | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'chatChannel': ChatChannelToJSON(value['chatChannel']),
        'events': ((value['events'] as Array<any>).map(ChatChannelEventToJSON)),
        'messages': ((value['messages'] as Array<any>).map(ChatMessageToJSON)),
        'notes': ((value['notes'] as Array<any>).map(PrivateNoteToJSON)),
    };
}

